const RETURN_URL_PARAM = "returnUrl";

const isSafeReturnPath = (path) => {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) {
    return false;
  }
  if (path.includes("://") || path.includes("\\")) return false;
  const pathname = path.split("?")[0].split("#")[0];
  if (
    pathname === "/" ||
    pathname === "/login" ||
    pathname === "/logout" ||
    pathname === "/unauthorized" ||
    pathname.startsWith("/auth/")
  ) {
    return false;
  }
  return true;
};

/** Read `returnUrl` from a login URL such as `/login?returnUrl=/tickets/12`. */
export const getReturnUrl = (search = window.location.search) => {
  try {
    const value = new URLSearchParams(search).get(RETURN_URL_PARAM);
    return isSafeReturnPath(value) ? value : null;
  } catch {
    return null;
  }
};

/** Login path that keeps the page the user tried to open. */
export const loginPathWithReturn = (path) => {
  const safe = isSafeReturnPath(path) ? path : getReturnUrl();
  if (!safe) return "/login";
  const params = new URLSearchParams();
  params.set(RETURN_URL_PARAM, safe);
  return `/login?${params.toString()}`;
};

export const currentLocationPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;
